export enum GlobalDashboardSortKind {
  ALPHABETICAL = 'ALPHABETICAL',
  NEWEST = 'NEWEST',
  MOST_POPULAR = 'MOST_POPULAR',
}
